import Footer from './components/Footer';
import Header from './components/Header';
import Settings from './components/Settings';
import SettingsProvider from './components/Settings/SettingsProvider';
import Timer from './components/Timer/Timer';
import '@/utils/sentry';

function App() {
  return (
    <div className="max-w-xl mx-auto flex flex-col h-dvh">
      <Header />
      <SettingsProvider>
        <main className="flex flex-col gap-6 grow p-4">
          <Settings />
          <Timer />
        </main>
      </SettingsProvider>
      <Footer />
    </div>
  );
}

export default App;
